import { useSelector } from 'react-redux'

import type { ShopAndRuntimeConfigState } from 'types/shopConfig'

const useShopAndRuntimeConfig = (): ShopAndRuntimeConfigState => {
  const { publicRuntimeConfig, shopConfig } = useSelector(
    (state: ShopAndRuntimeConfigState) => state
  )

  return { publicRuntimeConfig, shopConfig }
}

export default useShopAndRuntimeConfig
